export function objectKeys<T>(obj: T): (keyof T)[] {
  return Object.keys(obj as any) as (keyof T)[];
}

export function objectEntries<T>(obj: T): [keyof T, T[keyof T]][] {
  return Object.entries(obj as any) as [keyof T, T[keyof T]][];
}

export function objectValues<T>(obj: T): T[keyof T][] {
  return Object.values(obj as any) as T[keyof T][];
}
